<template>
  <div>
    <!-- flg settings -->
    <p class="title is-5">FLG settings</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="flgSettings.client.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label"></label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <label class="checkbox">
              <input v-model="flgSettings.client.isTestEnvironment" type="checkbox">
              Test environment
            </label>
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import flgService from '../../../../services/flg.service';

  export default {
    name: 'client-settings-flg',
    data() {
      return {
        flgSettings: {
          server: {},
          client: {}
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.flgSettings = await flgService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await flgService.save(this.clientId, this.flgSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/flg.vue